import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";



export const useCreatePortalDocument = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (dto: { file: File; label?: string | null }) => {
      const form = new FormData();
      form.append("file", dto.file);
      if (dto.label !== undefined) {
        form.append("label", dto.label == null ? "" : dto.label);
      }

      // Override global JSON header for multipart upload.
      const { data } = await api.post("/portal/documents", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["client-profile"] });
      qc.invalidateQueries({ queryKey: ["client-dashboard"] });
    },
  });
}



export const useDeletePortalDocument = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      portalClientId,
    }: {
      id: string;
      portalClientId?: string;
    }) => {
      await api.delete(`/portal/documents/${id}`, {
        headers: portalClientId
          ? { "X-Portal-Client-Id": portalClientId }
          : undefined,
      });
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["client-profile"] });
      qc.invalidateQueries({ queryKey: ["client-dashboard"] });
    },
  });
}



export const useUpdatePortalDocumentLabel = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      label,
      portalClientId,
    }: {
      id: string;
      label: string | null;
      portalClientId?: string;
    }) => {
      const { data } = await api.patch(`/portal/documents/${id}`, { label }, {
        headers: portalClientId
          ? { "X-Portal-Client-Id": portalClientId }
          : undefined,
      });
      return data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["client-profile"] });
      qc.invalidateQueries({ queryKey: ["client-dashboard"] });
    },
  });
}
